import React, { useEffect, useState, useContext, useRef } from "react";
import "../../css/Stylesheet-T.css";
import Loader from "../Props/Loader";
import MyContext from "../MyContext";
import AlertBox from "../Props/AlertBox";
import AlertBoxError from "../Props/AlertBoxError";
import MainButton from "./../Props/MainButton";
import LensCreationTable from "./LensCreationTable";
import ItemGroupAPI from "../../API/APIServices/ItemGroup";
import LensPowerMasterApi from "../../API/APIServices/LensItemCreation";
import { useNavigate } from "react-router-dom";
import LensItemCreation from "../../API/APIServices/LensItemCreation";
import ItemMaster from "../Master/InvertoryMaster/ItemMaster";
import Account from "../../API/APIServices/Account";
import RangeInput from "./RangeInput";
import Swal from "sweetalert2";
import MastersModalBox from "../Props/MastersModalBox";
import LensCreationTable1 from "./LensCreationTable1";
import Transaction from "../../API/APIServices/Transaction";

const LensitemDataModal = (props) => {
  const {
    OpenAlertBox,
    alertBox,
    setAlertBox,
    OpenAlertBoxEdit,
    alertBoxEdit,
    alertBoxErrorUpdate,
    alertBoxErrorInsert,
    OpenAlertBoxErrorInsert,
    OpenAlertBoxErrorUpdate,
  } = useContext(MyContext);

  const {
    LensPowerItem,
    closeModal,
    setItemMasterRows,
    setChangeInData,
    ReferenceNumber,
    GetProductDataFunction,
    TransAccountId,
    LensPowerItemRowindex,
    handleDeleteRow,
  } = props;

  console.log("LensPowerItem", LensPowerItem);

  function parseBoolean(value) {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (["false", "0", "no", "off", ""].includes(normalized)) return false;
      if (["true", "1", "yes", "on"].includes(normalized)) return true;
    }
    return Boolean(value);
  }

  useEffect(() => {
    const getData = async () => {
      if (LensPowerItem) {
        const data = await LensItemCreation.getLensItemCreationByItemId(
          LensPowerItem.d2_Id
        );
        if (data) {
          setInputValues({
            ParentGrp: LensPowerItem.parentGrp,
            ItemName: LensPowerItem.productName,
            ItemId: LensPowerItem.d2_Id,
            SPH_Min: data.spH_Min,
            SPH_Max: data.spH_Max,
            SPH_Step: data.spH_Step,
            CYL_Min: data.cyL_Min,
            CYL_Max: data.cyL_Max,
            CYL_Step: data.cyL_Step,
            // Axis: data.axis?.split(",")[0],
            Axis: data.axis,
            Add_Min: data.add_Min,
            Add_Max: data.add_Max,
            Add_Step: data.add_Step,
            Eye: data.eye,
            Changed: true,
          });
          setIsExistingItem(true);
          const numbersArray = data.axis
            .split(",")
            .map((num) => parseInt(num, 10));
          setAxisValueForExisting(numbersArray);
          setSelectedAxis(data.axis?.split(",")[0] || "");
        } else {
          closeModal();
          alert("No lens Found");
        }
      }
    };

    getData();
  }, [LensPowerItem]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [isHovered3, setIsHovered3] = useState(false);
  const [combinedV, setcombined] = useState([]);

  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const [fetchLensPowerData, setfetchLensPowerData] = useState([]);

  const [sphValue, setSphValues] = useState([]);
  const [cylValue, setCylValues] = useState([]);
  const [axisValue, setAxisValues] = useState([]);
  const [addValue, setAddValues] = useState([]);

  useEffect(() => {
    console.log("fetchLensPowerData", fetchLensPowerData);
  }, [fetchLensPowerData]);

  useEffect(() => {}, []);

  const [inputValues, setInputValues] = useState({
    ParentGrp: "",
    ItemName: "",
    ItemId: "",
    SPH_Min: "0",
    SPH_Max: "0",
    SPH_Step: "0.25",
    CYL_Min: "0",
    CYL_Max: "0",
    CYL_Step: "0.25",
    Axis: "",
    Add_Min: "0",
    Add_Max: "0",
    Add_Step: "0.25",
    Eye: "RL",
    itemIds: [],
    Changed: false,
    isCrossCompound: false,
  });

  useEffect(() => {
    console.log("inputValues", inputValues);
  }, [inputValues]);

  const [isUpdated, setIsUpdated] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const [totalRecords, setTotalRecords] = useState();
  const [pageSize, setpageSize] = useState(5000);

  const handlenext = () => {
    const totalPages = Math.ceil(totalRecords / pageSize);
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };
  const handleprev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  const [isReversed, setIsReversed] = useState(false);

  const ChangeDirectionofData = () => {
    setIsReversed(!isReversed);
  };

  const ShowButtonClick = async (value) => {
    ;
    setLoading(true);
    if (inputValues.ItemId == "") {
      alert("Product selection is required");
      return;
    }
    if (inputValues.Eye == "") {
      alert("Please Select Requried values");
      return;
    }
    try {
      let val;
      let axis;

      if (value && !isNaN(value)) {
        axis = value;
      } else if (
        axisValueForExisting &&
        axisValueForExisting[0] &&
        !isNaN(axisValueForExisting[0])
      ) {
        axis = axisValueForExisting[0];
      } else {
        axis = "";
      }
      if (isExistingItem) {
        const data = {
          ...inputValues,
          pageNumber: currentPage,
          pageSize,
          Axis: axis,
        };
        val = await LensPowerMasterApi.getLensItemCreationById1(data);
      } else {
        val = await LensPowerMasterApi.getLensItemCreationById1(inputValues);
      }
      console.log(val);
      var ITEMS = val.result.items;
      if (val !== null) {
        const isCross = parseBoolean(inputValues.isCrossCompound);
        if (!isCross) {
          CreateLensPowerClick(axis, ITEMS);
        } else {
          CreateLensPowerCrossClick(axis, ITEMS);
        }
        setLoading(false);
        setfetchLensPowerData(val.result.items);
        setTotalRecords(val.totalRecords);
      } else {
        setLoading(false);
        alert("No lens power created");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [ItemGroupList, setItemGroupList] = useState([]);
  const [ItemMasterList, setItemMasterList] = useState([]);

  useEffect(() => {
    const fetchItemGroupMaster = async () => {
      try {
        const val = await ItemGroupAPI.GetItemGroup();
        console.log(val);
        setItemGroupList(val);
      } catch (error) {
        console.log(error);
      }
    };

    fetchItemGroupMaster();
  }, []);
  const [isModalOpen2, setModalOpen2] = useState(false);

  const showModal2 = () => {
    setModalOpen2(!isModalOpen2);
  };

  // useEffect(() => {
  //   const fetchItemMaster = async () => {
  //     try {
  //       const val = await LensPowerMasterApi.GetLensItemMaster();
  //       console.log(val);
  //       setItemMasterList(val);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   fetchItemMaster();
  // }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    if (inputValues.Changed) {
      setIsUpdated(true);
    }

    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    //setErrorMessages((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const [SelectedAxis, setSelectedAxis] = useState();

  const handleAxisChange = (event) => {
    setSelectedAxis(event.target.value);
    // ShowButtonClick(event.target.value);
  };

  const CreateLensPowerClick = (value, ITEMS) => {
    ;
    if (inputValues != null) {
      const getUniqueSorted = (values) => {
        return [
          ...new Set(
            values.filter(
              (val) => val !== null && val !== undefined && !isNaN(val)
            )
          ),
        ]
          .sort((a, b) => a - b)
          .map((val) => parseFloat(val).toFixed(2));
      };

      // Create the arrays
      var sph = getUniqueSorted(ITEMS.map((item) => item.sph));
      var cyl = getUniqueSorted(ITEMS.map((item) => item.cyl));
      var add = getUniqueSorted(ITEMS.map((item) => item.add));

      if (sph.length > 0) {
        setSphValues(sph);
      } else {
        sph = ["0.00"];
        setSphValues(["0.00"]);
      }
      if (cyl.length > 0) {
        setCylValues(cyl);
      } else {
        cyl = ["0.00"];
        setCylValues(["0.00"]);
      }
      if (add.length > 0) {
        setAddValues(add);
      } else {
        add = ["0.00"];
        setAddValues(["0.00"]);
      }

      // Get all unique valid axis values
      var axis = [
        ...new Set(
          ITEMS.map((item) => item.axis).filter(
            (val) => val !== null && val !== undefined && !isNaN(val)
          )
        ),
      ].sort((a, b) => a - b);

      if (axis.length > 0) {
        setAxisValues(axis);
      } else {
        axis = ["0"];
        setAxisValues(["0"]);
      }
      // Get all unique valid eye values
      const eyeTypes = [
        ...new Set(
          ITEMS.map((item) => item.eye).filter(
            (val) => val !== null && val !== undefined
          )
        ),
      ];

      // }

      document.getElementById("table").style.display = "block";

      let combined = [];
      if (axisValue && axisValue.length > 0) {
        if (isExistingItem) {
          axis.forEach((axis_element) => {
            sph.forEach((sph_element) => {
              cyl.forEach((cyl_element) => {
                combined.push({
                  sph: sph_element,
                  cyl: cyl_element,
                  axis: axis_element,
                });
              });
            });
          });
        } else {
          axisValue.forEach((axis_element) => {
            sphValue.forEach((sph_element) => {
              cylValue.forEach((cyl_element) => {
                combined.push({
                  sph: sph_element,
                  cyl: cyl_element,
                  axis: axis_element,
                });
              });
            });
          });
        }
      } else {
        axis.forEach((axis_element) => {
          sph.forEach((sph_element) => {
            cyl.forEach((cyl_element) => {
              combined.push({
                sph: sph_element,
                cyl: cyl_element,
                axis: axis_element,
              });
            });
          });
        });
      }
      setcombined(combined);
    }
  };

  const CreateLensPowerCrossClick = (value, ITEMS) => {
    ;
    if (inputValues != null) {
      // Utilities
      const filterValid = (values) =>
        values.filter(
          (val) => val !== null && val !== undefined && !isNaN(val)
        );
      const getUniqueSorted = (values) =>
        [...new Set(filterValid(values))]
          .sort((a, b) => a - b)
          .map((val) => parseFloat(val).toFixed(2));

      const getStepFromSorted = (sortedValues) =>
        sortedValues.length >= 2
          ? (parseFloat(sortedValues[1]) - parseFloat(sortedValues[0])).toFixed(
              2
            )
          : null;
      const sphRaw = ITEMS.map((item) => item.sph);
      const cylRaw = ITEMS.map((item) => item.cyl);
      const addRaw = ITEMS.map((item) => item.add);
      const axisRaw = ITEMS.map((item) => item.axis);
      const eyeRaw = ITEMS.map((item) => item.eye);

      var sph = getUniqueSorted(sphRaw);
      var cyl = getUniqueSorted(cylRaw);
      var add = getUniqueSorted(addRaw);
      var axis = getUniqueSorted(axisRaw.map(Number)); // Ensures numeric sorting
      var eyeTypes = [...new Set(filterValid(eyeRaw))]; // Keep as strings

      if (sph.length > 0) {
        setSphValues(sph);
      } else {
        sph = ["0.00"];
        setSphValues(["0.00"]);
      }
      if (cyl.length > 0) {
        setCylValues(cyl);
      } else {
        cyl = ["0.00"];
        setCylValues(["0.00"]);
      }
      if (add.length > 0) {
        setAddValues(add);
      } else {
        add = ["0.00"];
        setAddValues(["0.00"]);
      }

      if (axis.length > 0) {
        setAxisValues(axis);
      } else {
        axis = ["0"];
        setAxisValues(["0"]);
      }

      const sphStep = getStepFromSorted(sph);

      document.getElementById("table").style.display = "block";

      let combined = [];
      if (axisValue && axisValue.length > 0) {
        if (isExistingItem) {
          axis.forEach((axis_element) => {
            sph.forEach((sph_element) => {
              const sphVal = parseFloat(sph_element);
              const minCyl = -(sphVal + Number(sphStep)); // Ensure sphStep is a number
              cyl.forEach((cyl_element) => {
                const cylVal = parseFloat(cyl_element);
                if (cylVal <= minCyl) {
                  combined.push({
                    sph: sph_element,
                    cyl: cyl_element,
                    axis: axis_element,
                  });
                }
              });
            });
          });
        } else {
          axisValue.forEach((axis_element) => {
            sphValue.forEach((sph_element) => {
              const sphVal = parseFloat(sph_element);
              const minCyl = -(sphVal + Number(sphStep)); // Ensure sphStep is a number
              cylValue.forEach((cyl_element) => {
                const cylVal = parseFloat(cyl_element);
                if (cylVal <= minCyl) {
                  combined.push({
                    sph: sph_element,
                    cyl: cyl_element,
                    axis: axis_element,
                  });
                }
              });
            });
          });
        }
      } else {
        axis.forEach((axisStr) => {
          sph.forEach((sphStr) => {
            const sphVal = parseFloat(sphStr);
            const minCyl = -(sphVal + Number(sphStep)); // Ensure sphStep is a number

            cyl.forEach((cylStr) => {
              const cylVal = parseFloat(cylStr);
              if (cylVal <= minCyl) {
                combined.push({
                  sph: sphStr,
                  cyl: cylStr,
                  axis: axisStr,
                });
              }
            });
          });
        });
      }

      setcombined(combined);
    }
  };

  const [ItemsArray, setItemsArray] = useState([]);

  const SaveLensItemData = async () => {
    ;
    handleDeleteRow(LensPowerItem.rowIndex, LensPowerItemRowindex);
    setLoading(true);
    if (ItemsArray && ItemsArray.length > 0) {
      var ProductTempData = await Transaction.SetProductTempDataForMultiple(
        ItemsArray,
        ReferenceNumber
      );
      // Handle API response
      if (ProductTempData.isSuccess === false) {
        console.log("API call failed. Response:", ProductTempData);
      } else if (ProductTempData.isSuccess === true) {
        setChangeInData(false);
        console.log("Product Temp Data saved successfully.");
        await GetProductDataFunction();
        closeModal();
      }
    }
  };

  const [filteredItems, setFilteredItems] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleInputChange1 = async (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setIsDropdownOpen(true);
    const filteredData = {
      MasterType: 4,
      GroupWiseSuggestion: false,
      GroupId: "",
      search_str: value,
      PageNumber: 1,
      PageSize: 15,
      IsEcomStore: false,
    };
    const searchItem1 = await Account.GetAccountListForAutoSuggestion(
      filteredData
    );
    setFilteredItems(searchItem1);
    setHighlightedIndex(-1);
  };

  const [isExistingItem, setIsExistingItem] = useState(false);
  const [axisValueForExisting, setAxisValueForExisting] = useState();

  const handleSelection = async (id, name, parentGrpId) => {
    const data = await LensItemCreation.getLensItemCreationByItemId(id);
   
    if (data) {
      setIsExistingItem(true);
      setInputValues((prevValues) => ({
        ...prevValues,
        ItemId: id,
        ItemName: name,
        ParentGrp: parentGrpId,
        SPH_Min: data.spH_Min,
        SPH_Max: data.spH_Max,
        SPH_Step: data.spH_Step,
        CYL_Min: data.cyL_Min,
        CYL_Max: data.cyL_Max,
        CYL_Step: data.cyL_Step,
        Axis: data.axis,
        Add_Min: data.add_Min,
        Add_Max: data.add_Max,
        Add_Step: data.add_Step,
        Eye: data.eye,
        Changed: true,
        isCrossCompound: data.isCrossCompound || false,
      }));
      const numbersArray = data.axis.split(",").map((num) => parseInt(num, 10));
      setAxisValueForExisting(numbersArray);
      setSelectedAxis(data.axis?.split(",")[0] || "");
    } else {
      setIsExistingItem(false);
      setInputValues((prevValues) => ({
        ...prevValues,
        ItemId: id,
        ItemName: name,
        ParentGrp: parentGrpId,
      }));
    }
    setIsDropdownOpen(false);
  };

  const handleKeyDownForProduct = (e) => {
    if (isDropdownOpen) {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setHighlightedIndex((prevIndex) =>
            prevIndex < filteredItems.length - 1 ? prevIndex + 1 : prevIndex
          );
          break;
        case "ArrowUp":
          e.preventDefault();
          setHighlightedIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : prevIndex
          );
          break;
        case "Enter":
          if (
            highlightedIndex >= 0 &&
            highlightedIndex < filteredItems.length
          ) {
            const selectedItem = filteredItems[highlightedIndex];
            handleSelection(
              selectedItem.id,
              selectedItem.name,
              selectedItem.parentGrpId
            );
          }
          break;
        case "Escape":
          setIsDropdownOpen(false);
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    // Auto-scroll the dropdown to ensure the highlighted item is always in view
    if (dropdownRef.current && highlightedIndex >= 0) {
      const listItem = dropdownRef.current.children[highlightedIndex];
      if (listItem) {
        const listContainer = dropdownRef.current;
        const itemTop = listItem.offsetTop;
        const itemBottom = itemTop + listItem.offsetHeight;
        const containerTop = listContainer.scrollTop;
        const containerBottom = containerTop + listContainer.offsetHeight;

        // If the item is out of view, scroll the container
        if (itemTop < containerTop) {
          listContainer.scrollTop = itemTop; // scroll to top of item
        } else if (itemBottom > containerBottom) {
          listContainer.scrollTop = itemBottom - listContainer.offsetHeight; // scroll to bottom of item
        }
      }
    }
  }, [highlightedIndex]);

  // const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  // const [focusedIndex, setFocusedIndex] = useState(-1);

  // const handleKeyDown = (event) => {
  //     if (event.key === "ArrowDown") {
  //         event.preventDefault();
  //         setFocusedIndex((prevIndex) => Math.min(prevIndex + 1, filteredItems.length - 1));
  //     } else if (event.key === "ArrowUp") {
  //         event.preventDefault();
  //         setFocusedIndex((prevIndex) => Math.max(prevIndex - 1, -1));
  //     } else if (event.key === "Enter" && focusedIndex !== -1) {
  //         event.preventDefault();
  //         const selectedItem = filteredItems[focusedIndex];
  //         handleSelection(selectedItem.d2Id, selectedItem.name);
  //         setFocusedIndex(-1);
  //     }
  // };

  const [dataToSendInUpdate, setDataToSendInUpdate] = useState([]);

  useEffect(() => {
    console.log("dataToSendInUpdate", dataToSendInUpdate);
  }, [dataToSendInUpdate]);

  // const GetdataForUpdate = (e, d2Id) => {
  //   ;

  //   const { name, value } = e.target;
  //   // console.log("name", name);
  //   // console.log("value", value);
  //   // console.log("d2Id", d2Id);

  //   setfetchLensPowerData((prevValues) =>
  //     prevValues.map(
  //       (item) =>
  //         item.d2Id === d2Id
  //           ? { ...item, [name]: value } // Update the object with matching d2Id
  //           : item // Keep other objects unchanged
  //     )
  //   );

  //   var Data = fetchLensPowerData.find((item) => item.d2Id == d2Id);
  //   if (Data) {
  //     console.log(Data);
  //     var dataCreatedToCreateArray = {
  //       itm_id: Number(Data.d2Id) || 0,
  //       barcode: Data.defaultBarcode || 0,
  //       iPurchasePrice: Number(Data.purchasePrice) || 0,
  //       iSalePrice: Number(Data.salePrice) || 0,
  //       iMrpPrice: Number(Data.mrpPrice) || 0,
  //       iCateRateA: Number(Data.cateRateA) || 0,
  //       iCateRateB: Number(Data.cateRateB) || 0,
  //       iCateRateC: Number(Data.cateRateC) || 0,
  //       iCateRateD: Number(Data.cateRateD) || 0,
  //       iCateRateE: Number(Data.cateRateE) || 0,
  //       iCateRateF: Number(Data.cateRateF) || 0,
  //       iCateRateG: Number(Data.cateRateG) || 0,
  //       iCateRateH: Number(Data.cateRateH) || 0,
  //       iCateRateI: Number(Data.cateRateI) || 0,
  //       iCateRateJ: Number(Data.cateRateJ) || 0,
  //       boxNo: Data.boxNumber || "",
  //       // qty: Number(Data.qty) || 0,
  //       alertQty: Number(Data.alertQty) || 0,
  //       openingStock: Number(Data.openingStock) || 0,
  //     };

  //     dataCreatedToCreateArray[name] = value;
  //     // Update the state by appending the new object to the existing array
  //     setDataToSendInUpdate((prevData) => {
  //       const exists = prevData.some(
  //         (item) => item.itm_id === dataCreatedToCreateArray.itm_id
  //       );
  //       if (exists) {
  //         // Replace the existing object with the updated one
  //         return prevData.map((item) =>
  //           item.itm_id === dataCreatedToCreateArray.itm_id
  //             ? dataCreatedToCreateArray
  //             : item
  //         );
  //       } else {
  //         // Append the new object if itm_id is not already in the array
  //         return [...prevData, dataCreatedToCreateArray];
  //       }
  //     });
  //   }
  // };

  const GetdataForUpdate = (e, d2Id) => {
    ;

    const { name, value } = e.target;

    // 🔹 Update fetchLensPowerData directly
    setfetchLensPowerData((prevValues) => {
      return prevValues.map((item) =>
        item.d2Id === d2Id ? { ...item, [name]: value } : item
      );
    });

    // 🔹 Update dataToSendInUpdate in the same step
    setDataToSendInUpdate((prevData) => {
      // Find existing item
      const existingItem = prevData.find((item) => item.itm_id === d2Id);

      const updatedItem = {
        ...existingItem,
        itm_id: Number(d2Id) || 0,
        barcode: existingItem?.defaultBarcode || 0,
        iPurchasePrice: Number(existingItem?.purchasePrice) || 0,
        iSalePrice: Number(existingItem?.salePrice) || 0,
        iMrpPrice: Number(existingItem?.mrpPrice) || 0,
        iCateRateA: Number(existingItem?.cateRateA) || 0,
        iCateRateB: Number(existingItem?.cateRateB) || 0,
        iCateRateC: Number(existingItem?.cateRateC) || 0,
        iCateRateD: Number(existingItem?.cateRateD) || 0,
        iCateRateE: Number(existingItem?.cateRateE) || 0,
        iCateRateF: Number(existingItem?.cateRateF) || 0,
        iCateRateG: Number(existingItem?.cateRateG) || 0,
        iCateRateH: Number(existingItem?.cateRateH) || 0,
        iCateRateI: Number(existingItem?.cateRateI) || 0,
        iCateRateJ: Number(existingItem?.cateRateJ) || 0,
        boxNo: existingItem?.boxNumber || "",
        alertQty: Number(existingItem?.alertQty) || 0,
        openingStock: Number(existingItem?.openingStock) || 0,
        [name]: value, // Apply the change dynamically
      };

      if (existingItem) {
        // Replace the existing object with the updated one
        return prevData.map((item) =>
          item.itm_id === d2Id ? updatedItem : item
        );
      } else {
        // Append if the object doesn't exist
        return [...prevData, updatedItem];
      }
    });
  };

  const handleDelete = async () => {
    if (inputValues.ItemId == "") {
      alert("Product selection is required");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      customClass: {
        title: "swal2-custom-title",
        confirmButton: "my-confirm-button",
        cancelButton: "my-cancel-button",

        popup: "swal2-custom-popup",
        htmlContainer: "swal2-custom-text",
        icon: "swal2-custom-icon",
      },
    });

    if (!result.isConfirmed) return;

    ;
    try {
      setLoading(true);
      const response = await LensItemCreation.deleteLensItemCreation(
        inputValues.ItemId
      );
      if (!response.isSuccess) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.errorMessages[0],
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Deleted Successfully",
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
      }
      console.log("Delete response", response);
    } catch (error) {
      alert("Error While Deleting");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const dropdownRefAddProducts = useRef(null);
  const [isDropdownOpenAddProducts, setIsDropdownOpenAddProducts] =
    useState(false);
  const [filteredItemsAddProducts, setFilteredItemsAddProducts] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);

  useEffect(() => {
    console.log("selectedProducts", selectedProducts);
  }, [selectedProducts]);
  // Handle adding a product
  const handleAddProduct = (item) => {
    if (!selectedProducts.some((p) => p.id === item.id)) {
      setSelectedProducts((prev) => [...prev, item]);

      setInputValues((prev) => ({
        ...prev,
        itemIds: [...(prev.itemIds || []), item.id], // Append new id
      }));
    }
    setSearchInput("");
  };

  // Handle removing a product
  const handleRemoveProduct = (id) => {
    setSelectedProducts((prev) => prev.filter((p) => p.id !== id));

    setInputValues((prev) => ({
      ...prev,
      itemIds: (prev.itemIds || []).filter((itemId) => itemId !== id),
    }));
  };

  const handleInputChangeForProducts = async (event) => {
    const { value } = event.target;
    setSearchInput(value);

    setIsDropdownOpenAddProducts(true);

    const filteredData = {
      MasterType: 4,
      GroupWiseSuggestion: false,
      GroupId: "",
      search_str: value,
      PageNumber: 1,
      PageSize: 15,
      IsEcomStore: false,
    };

    const searchItem1 = await Account.GetAccountListForAutoSuggestion(
      filteredData
    );
    setFilteredItemsAddProducts(searchItem1);
    setHighlightedIndex(-1);
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      {/* *******************Top Navbar/Buttons****************** */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#212e4f",
        }}
      >
        <div className="panel-head-title">
          <h2
            className="panel-title"
            style={{ color: "white", fontWeight: "600" }}
          >
            Lens Qty Data Change
          </h2>
        </div>
        <MainButton
          isBackButton={false}
          SaveButton={SaveLensItemData}
          isLogoutButton={false}
          isResetButton={false}
          isAdminName={true}
          SaveButtonName="Done"
        />
      </div>
      {/* ******************* Body ****************** */}
      <div className="mt-1" style={{ padding: "15px", position: "relative" , paddingBottom:"0px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            marginLeft: "12px",
            alignItems: "center",
          }}
        >
          <label>Group Name &nbsp;</label>
          <select
            style={{
              width: "120px",
              padding: "5px , 10px",
              marginRight: "15px",
            }}
            className="table-input"
            onChange={handleInputChange}
            value={inputValues.ParentGrp}
            name="ParentGrp"
          >
            <option>-Select-</option>
            {ItemGroupList !== undefined &&
            ItemGroupList !== null &&
            ItemGroupList.length > 0 ? (
              ItemGroupList.map((group, index) => (
                <option key={index} value={group.d2_Id}>
                  {group.name}
                </option>
              ))
            ) : (
              <option value="">No groups available</option>
            )}
          </select>

          <label> &nbsp; Product Name &nbsp;</label>

          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              onKeyDown={handleKeyDownForProduct}
              type="text"
              className="table-input"
              style={{ width: "150px", padding: "5px , 10px" }}
              value={inputValues.ItemName}
              name="ItemName"
              onChange={handleInputChange1}
              placeholder="Type to search..."
              onBlur={() => {
                setTimeout(() => {
                  setIsDropdownOpen(false);
                }, 500);
              }}
              autoComplete="off"
            />

            <ul
              ref={dropdownRef}
              style={{
                display: isDropdownOpen ? "block" : "none",
                position: "absolute",
                maxHeight: "250px",
                padding: "0",
                width: "250px",
                top: "50px",
                zIndex: 999,
                fontSize: "15px",
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                overflow: "auto",
              }}
            >
              {filteredItems.map((item, index) => (
                <li
                  key={index}
                  onClick={() =>
                    handleSelection(item.id, item.name, item.parentGrpId)
                  }
                  style={{
                    cursor: "pointer",
                    borderBottom: "1px solid #ccc",
                    padding: "5px 10px",
                    margin: "0",
                    backgroundColor:
                      highlightedIndex === index ? "#eee" : "white",
                  }}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {/* Selected Products Display */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
              {selectedProducts.map((product) => (
                <div
                  key={product.id}
                  style={{
                    padding: "5px 10px",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "15px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {product.name.length > 10
                    ? `${product.name.slice(0, 10)}...`
                    : product.name}
                  <span
                    onClick={() => handleRemoveProduct(product.id)}
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      color: "red",
                    }}
                  >
                    ×
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* <label className="col-sm-3 w-8">Power Range</label> */}
        {/* <div className="ToolTipTOp">
          <div className="mt-1">
            <div className="input-box-m6">
              <div className=" ToolBody">
                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    SPH Min
                  </label>
                  <input
                    id="sph_min"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.SPH_Min}
                    onChange={handleInputChange}
                    name="SPH_Min"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">SPH Range -40.00 to +40.00</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    SPH Max
                  </label>
                  <input
                    id="sph_max"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.SPH_Max}
                    onChange={handleInputChange}
                    name="SPH_Max"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">SPH Range -40.00 to +40.00</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Step
                  </label>
                  <input
                    id="sph_step"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.SPH_Step}
                    onChange={handleInputChange}
                    name="SPH_Step"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Step 0.25</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    CYL Min
                  </label>
                  <input
                    id="cyl_min"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.CYL_Min}
                    onChange={handleInputChange}
                    name="CYL_Min"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">CYL Range -10.00 to +10.00</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    CYL Max
                  </label>
                  <input
                    id="cyl_max"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.CYL_Max}
                    onChange={handleInputChange}
                    name="CYL_Max"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">CYL Range -10.00 to +10.00</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Step
                  </label>
                  <input
                    id="cyl_step"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.CYL_Step}
                    onChange={handleInputChange}
                    name="CYL_Step"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Step 0.25</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Axis
                  </label>
                  <input
                    id="axis"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Axis}
                    onChange={handleInputChange}
                    name="Axis"
                    type="text"
                    required
                  />
                  <div class="tooltiptext">
                    Axis separated by comma (Ex- 10,20,...etc)
                  </div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Add Min
                  </label>
                  <input
                    id="add_min"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Add_Min}
                    onChange={handleInputChange}
                    name="Add_Min"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Add Range 0.50 to +10.00</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Add Max
                  </label>
                  <input
                    id="add_max"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Add_Max}
                    onChange={handleInputChange}
                    name="Add_Max"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Add Range 0.50 to +10.00</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Step
                  </label>
                  <input
                    id="add_step"
                    className=" table-input box-size1 toolTextWdth"
                    value={inputValues.Add_Step}
                    onChange={handleInputChange}
                    name="Add_Step"
                    type="number"
                    required
                  />
                  <div class="tooltiptext">Step 0.25</div>
                </div>

                <div class="tooltip6">
                  <label
                    className=" "
                    style={{ textAlign: "center", marginLeft: "5px" }}
                  >
                    Eye(RL/R/L)
                  </label>
                  <select
                    className="modify_im_input mode_category table-input"
                    style={{ width: "90px" }}
                    value={inputValues.Eye}
                    onChange={handleInputChange}
                    name="Eye"
                    type="text"
                    required
                  >
                    <option value="" disabled></option>
                    <option value="R">R</option>
                    <option value="L">L</option>
                    <option value="RL">RL</option>
                  </select>

                  <div class="tooltiptext">R/L/RL</div>
                </div>
                
              </div>
            </div>
          </div>
        </div> */}

        <RangeInput
          inputValues={inputValues}
          handleInputChange={handleInputChange}
          maxInputWidth={"80px"}
        />

        {/********************* Bottom Buttons ******************/}
        <div style={{ paddingTop: "10px", marginTop: "5px" }}>
          <div
            className="space-between"
            style={{ alignItems: "center", margin: "0px 8px 0px 15px" }}
          >
            <div className="space-evenly">
              {/* <input type="checkbox" />
              <label className="mt-1">&nbsp; Add Barcode with Lens Power</label> */}
              {/* {isExistingItem && (
                <div>
                  <div class="tooltip6" style={{ width: "250px" }}>
                    <label
                      className=" "
                      style={{ textAlign: "center", marginLeft: "50px" }}
                    >
                      Axis
                    </label>
                    <select
                      className="modify_im_input mode_category table-input"
                      style={{ width: "90px" }}
                      // value={inputValues.axis.split(',')}
                      onChange={handleAxisChange}
                      name="Eye"
                      type="text"
                      required
                    >
                      {axisValueForExisting &&
                        axisValueForExisting.map((item) => (
                          <option value={item}>{item}</option>
                        ))}
                    </select>
                  </div>
                </div>
              )} */}
            </div>
            <div className="space-evenly" style={{ position: "relative" }}>
              {/* <button
                className="btn-blue ml-10"
                onClick={() => CreateLensPowerClick(null)}
                style={{ backgroundColor: "darkgreen" }}
              >
                Show Structure
              </button> */}
              {isExistingItem && (
                <div class="tooltip6" style={{ width: "120px" }}>
                  <label
                    className=" "
                    style={{ textAlign: "center", marginRight: "5px" }}
                  >
                    Axis
                  </label>
                  <select
                    className="modify_im_input mode_category table-input"
                    style={{ width: "100px" }}
                    // value={inputValues.axis.split(',')}
                    onChange={handleAxisChange}
                    name="Eye"
                    type="text"
                    required
                  >
                    {axisValueForExisting &&
                      axisValueForExisting.map((item) => (
                        <option value={isNaN(item) ? "" : item}>
                          {isNaN(item) ? "" : item}
                        </option>
                      ))}
                  </select>
                </div>
              )}
              <button
                // className="ml-10 btn-red table-input box-size1 mt-2"
                className="btn-blue ml-10"
                onMouseEnter={() => setIsHovered3(true)}
                onMouseLeave={() => setIsHovered3(false)}
                onClick={() => ShowButtonClick(SelectedAxis || null)}
                type="number"
                required
                style={{
                  backgroundColor: "darkgreen",
                  padding: "5px",
                  height: "auto",
                  width: "100%",
                  border: "none",
                }}
              >
                Show Existing
              </button>
              <button
                className="lensitemmodalbtn"
                onClick={() => ChangeDirectionofData()}
              >
                <i class="fa-solid fa-arrows-up-down"></i>
              </button>
              {/* {isHovered3 && (
                <div className="hover-text2">
                  Show Lens power details which is save in database
                </div>
              )} */}
            </div>
          </div>
        </div>
        <div className="mt-3" id="LensTable" style={{ display: "block" }}>
          <LensCreationTable1
            combinedV={combinedV}
            sphValue={sphValue}
            cylValue={cylValue}
            axisValue={axisValue}
            addValue={addValue}
            fetchLensPowerData={fetchLensPowerData}
            GetdataForUpdate={GetdataForUpdate}
            setItemMasterRows={setItemMasterRows}
            ItemsArray={ItemsArray}
            setItemsArray={setItemsArray}
            setLoading={setLoading}
            TransAccountId={TransAccountId}
            LensPowerItem={LensPowerItem}
            isReversed={isReversed}
          />
        </div>
        {/* <PaginationControl
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          onPrevious={handleprev}
          onNext={handlenext}
        /> */}
      </div>

      {alertBox && (
        <AlertBox
          HeadingTop="Saved"
          Heading="Your Item Master is Saved"
          onYesClick={OpenAlertBox}
          singleButton={true}
          OpenAlertBox={OpenAlertBox}
        />
      )}

      {alertBoxEdit && (
        <AlertBox
          HeadingTop="Updated"
          Heading="Your Item Master is Updated"
          onYesClick={OpenAlertBoxEdit}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxEdit}
        />
      )}

      {alertBoxErrorInsert && (
        <AlertBoxError
          HeadingTop="ERROR"
          Heading="Error While inserting Data"
          onYesClick={OpenAlertBoxErrorInsert}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxErrorInsert}
        />
      )}

      {alertBoxErrorUpdate && (
        <AlertBoxError
          HeadingTop="ERROR"
          Heading="Error While Updating Data"
          onYesClick={OpenAlertBoxErrorUpdate}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxErrorUpdate}
        />
      )}
      {loading && <Loader />}
      {isModalOpen2 && (
        <MastersModalBox closeModal={showModal2}>
          <ItemMaster modelOpen={showModal2} />
        </MastersModalBox>
      )}
    </div>
  );
};

export default LensitemDataModal;

{
  /*<select
    className=""
    onChange={handleInputChange}
    value={inputValues.ItemId}
    name="ItemId"
>
    <option>-Select-</option>
    {ItemMasterList !== undefined &&
        ItemMasterList !== null
        && ItemGroupList.length > 0 ? (
        ItemMasterList.map((group, index) => (

            <option key={index} value={group.d1Id}>
                {group.name}
            </option>
        ))
    ) : (
        <option value="">
            No Item available
        </option>
    )}
</select>
*/
}
